module.exports = __webpack_public_path__ + "static/img/oca-environment-report.984b990.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/oca-environment-report.jpg
// module id = 3J1s
// module chunks = 0